/**
 *
 * Dropdown Component
 *
 */

import PropTypes from 'prop-types';
import React from 'react';

import StyledReactSelect from '../StyledReactSelect';

const Dropdown = ({ options, value, isSearchable, onChange, ...otherProps }) => {
  const modifiedOnChange = option => onChange((option && option.value) || option);
  const selectedOption = options && options.find(option => option.value === value);

  return (
    <StyledReactSelect
      isSearchable={!!isSearchable}
      onChange={modifiedOnChange}
      options={options}
      value={selectedOption}
      {...otherProps}
    />
  );
};

Dropdown.propTypes = {
  isSearchable: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]),
};

export default Dropdown;
